import styled from 'styled-components';

import { displayPrice } from '../../utils';
import { colors, spacing } from '../../constants';
import { useTranslation } from 'react-i18next';

const PriceFrom = styled.span``;
const Text = styled.span``;
const Price = styled.span``;

interface IProps {
    bold?: boolean;
    className?: string;
    highlight?: boolean;
    isDiscount?: boolean;
    isTotal?: boolean;
    item: string;
    price: number;
    priceFrom?: number;
    included?: boolean;
}

const BasePriceLine = ({
    className,
    isDiscount,
    item,
    price,
    priceFrom,
    included,
}: IProps) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            {item}
            <span>
                {priceFrom && <PriceFrom>{displayPrice(priceFrom)}</PriceFrom>}

                {included ? (
                    <Text>{t('included')}</Text>
                ) : (
                    <Price>
                        {isDiscount && '-'} {displayPrice(price)}
                    </Price>
                )}
            </span>
        </div>
    );
};

export const PriceLine = styled(BasePriceLine)`
    padding: ${spacing.sm} 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: ${({ bold }) => (bold ? 700 : 400)};
    font-size: ${({ isTotal }) => (isTotal ? '18px' : '16px')};
    color: ${({ highlight }) => highlight && colors.primary};

    span {
        font-size: ${({ isTotal }) => (isTotal ? '20px' : '18px')};
    }

    ${PriceFrom} {
        color: ${colors.grey};
        position: relative;
        margin-right: 20px;

        ::after {
            content: ' ';
            width: 50px;
            height: 2px;
            position: absolute;
            display: block;
            background-color: ${colors.grey};
            top: 45%;
            left: -5px;
            transform: rotate(-15deg);
        }
    }

    ${Text} {
        font-size: 14px;
    }
`;
